export function formatTime12(time: string): string {
  const [hStr, mStr] = (time ?? '').split(':');
  const hours = Number(hStr);
  const minutes = Number(mStr);
  if (Number.isNaN(hours) || Number.isNaN(minutes)) {
    return time ?? '';
  }
  const period = hours >= 12 ? 'PM' : 'AM';
  const hour12 = hours % 12 === 0 ? 12 : hours % 12;
  return `${hour12}:${`${minutes}`.padStart(2, '0')} ${period}`;
}

export function durationLabel(departure: string, arrival: string): string {
  const dep = toMinutes(departure);
  const arr = toMinutes(arrival);
  if (dep == null || arr == null) {
    return '';
  }
  let diff = arr - dep;
  if (diff < 0) {
    diff += 24 * 60;
  }
  const hours = Math.floor(diff / 60);
  const minutes = diff % 60;
  return minutes === 0 ? `${hours}h` : `${hours}h ${minutes}m`;
}

export function formatDateLong(date: string): string {
  const parsed = parseDate(date);
  if (!parsed) {
    return date;
  }
  return parsed.toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

export function formatDateShort(date: string): string {
  const parsed = parseDate(date);
  if (!parsed) {
    return date;
  }
  return parsed.toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

export function formatCurrency(amount: number | null | undefined): string {
  const value = amount ?? 0;
  return `\u20B1${value.toLocaleString('en-PH', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })}`;
}

export function seatLabel(row: number, column: number): string {
  return `${row}-${column}`;
}

function toMinutes(time: string): number | null {
  const [h, m] = (time ?? '').split(':').map(Number);
  if (Number.isNaN(h) || Number.isNaN(m)) {
    return null;
  }
  return h * 60 + m;
}

function parseDate(date: string): Date | null {
  if (!date) {
    return null;
  }
  const [year, month, day] = date.split('-').map(Number);
  if (!year || !month || !day) {
    return null;
  }
  return new Date(year, month - 1, day);
}
